import { atom, selector } from "recoil";
import { ApiClient } from "TaxAnalyticsHelpers";
import { EntityDTO, FileDTO, OrderDTO, UserDTO } from 'TaxAnalyticsHelpers/TaxAnalyticsClient';

interface AuthError {
    message: string;
    debug: any;
}
export interface AuthenticatedUser {
    isAuthenticated: boolean;
    user?: UserDTO;
    error?: AuthError;
    initials?: string;
    displayName?: string;
    givenName?: string;
    authenticating: boolean;
}

export const userState = atom<AuthenticatedUser>({
    key: "userState",
    default: {
        isAuthenticated: false,
        user: undefined,
        error: undefined,
        initials: "",
        displayName: "",
        givenName: "",
        authenticating: true
    },
});

export const isAuthenticating = selector({
    key: 'checkUserState',
    get: ({ get }) => {
        const state = get(userState);
        return state.authenticating;
    },
});

export const homeState = atom({
    key: "homeState",
    default: {
        newServices: false
    },
});

export const fetchUserEntities = selector({
    key: 'userEntitiesSelector',
    get: async ({ get }) => {
        try {
            var user = get(userState);
            if (!user.isAuthenticated)
                return [];
            const response = (await ApiClient.entityClient.all()).sort((a, b) => (a.name! > b.name!) ? 1 : ((b.name! > a.name!) ? -1 : 0));
            return response;
        }
        catch (error) {
            throw error;
        }
    }
});

export const fetchUserOrders = selector({
    key: 'userOrdersSelector',
    get: async ({ get }) => {
        try {
            var user = get(userState);
            if (!user.isAuthenticated)
                return [];
            const response = (await ApiClient.entityClient.orders()).sort((a, b) => (a.lastEventDate! > b.lastEventDate!) ? 1 : ((b.lastEventDate! > a.lastEventDate!) ? -1 : 0));
            return response;
        }
        catch (error) {
            throw error;
        }
    }
});

export const fetchUserAnalysis = selector({
    key: 'userAnalysisSelector',
    get: async ({ get }) => {
        try {
            var user = get(userState);
            if (!user.isAuthenticated)
                return [];
            const response = await ApiClient.analyticsClient.all();
            return response;
        }
        catch (error) {
            throw error;
        }
    }
});

export const selectedEntityState = atom<EntityDTO | undefined>({
    key: "workspaceSelectedEntity",
    default: undefined
});
export const selectedEntityFilesState = atom<FileDTO[] | undefined>({
    key: "workspaceSelectedEntityFiles",
    default: undefined
});

export const selectedOrderState = atom<OrderDTO | undefined>({
    key: "workspaceSelectedOrder",
    default: undefined
});
export const selectedOrderFilesState = atom<FileDTO[]>({
    key: "workspaceSelectedOrderFiles",
    default: []
});